export default __webpack_public_path__ + "static/media/video.dfaee16b.mp4";